export default __webpack_public_path__ + "static/media/Erik-foto.655dc3b3.png";